<div class="form-container">
  <div class="form-header">
    <h1>{{ 'project_step_result_title' | translate }}</h1>
  </div>

  <div class="form-content">
    <div *ngIf="scenario" class="solutions">
      <div class="title">
        <div class="title-left">
          <h3>{{ 'project_result_select_solutions' | translate }}</h3>
          <div class="btn-add ms-3">
            <button mat-mini-fab (click)="addSolution(scenario)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="solutions-list">
        <div class="solutions-tabs-container" cdkDropList (cdkDropListDropped)="onSolutionDrop($event, scenario)" cdkDropListOrientation="horizontal">
          <div class="solution-tab" *ngFor="let solution of scenario.solutions; let index = index; trackBy: trackByIndexFn" cdkDrag cdkDragHandle style="cursor: move">
            <div class="tab-content">
              <div class="tab-info" [matTooltip]="'project_result_drag_reorder' | translate">
                <mat-icon class="drag-handle">drag_indicator</mat-icon>
                <span class="solution-name">{{ solution.displayName }}</span>
              </div>

              <div class="tab-actions">
                <button mat-icon-button [matTooltip]="'project_result_deselect' | translate" class="action-btn delete" (click)="deleteSolution(index, scenario, solution); $event.stopPropagation()">
                  <mat-icon>remove_circle_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="indicators-section" *ngIf="scenario">
      <div class="indicators-header">
        <div class="indicator-selector">
          <span class="selector-label">{{ 'project_result_select_indicators' | translate }}</span>
        </div>
      </div>
      <div class="indicators-grid">
        <div class="indicator-item" *ngFor="let item of scenario?.indicatorSelected">
          <mat-checkbox [checked]="item?.isChecked || false" (change)="onIndicatorChange(item, $event)">
            {{ item?.displayName | localizedLabel: 'indicator' : item?.code }}
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="synthesis-button-container" *ngIf="scenario && hasModifications">
  <button mat-raised-button class="synthesis-btn" (click)="toggleSynthese()">
    <mat-icon>assessment</mat-icon>
    <span>{{ 'project_result_refresh_synthesis' | translate }}</span>
  </button>
</div>

<div *ngIf="(isLoading$ | async) !== true && scenario" class="synthese-container">
  <app-synthese [scenario]="scenario!" [projectId]="projectId" [refreshKey]="refreshKey"></app-synthese>
</div>
